import { withAuthenticationRequired } from "@auth0/auth0-react";
import { NextPage } from "next";
import { useRouter } from "next/router";

import { KycIncomplete } from "../../../components/kyc/KycIncomplete";
import { assertNever } from "../../../utils/assertNever";

const ApplyWithCode: NextPage = () => {
    const router = useRouter();
    const {
        query: { inviteCode: inviteCodeQueryParam },
    } = router;

    const inviteCode = getInviteCodeFromQueryParam(inviteCodeQueryParam);

    return <KycIncomplete inviteCode={inviteCode} />;
};

function getInviteCodeFromQueryParam(queryParam: string | string[] | undefined): string | undefined {
    if (queryParam == null) {
        // Should not be matched by this route.
        throw new Error("Invite code param should not be empty.");
    } else if (Array.isArray(queryParam)) {
        // Should not be matched by this route.
        throw new Error("Invite code param should not be array.");
    } else if (typeof queryParam === "string") {
        return queryParam;
    }
    return assertNever(queryParam);
}

export default withAuthenticationRequired(ApplyWithCode, {
    loginOptions: { authorizationParams: { screen_hint: "signup" } },
});
